export type HapticType = 'light' | 'medium' | 'success' | 'warning' | 'selection';

/**
 * Lightweight tactile haptic feedback using Web Vibration API (PLAN UI_UX.md Module 6.3).
 * Safe against non-browser environments and platforms without vibration hardware.
 */
export function triggerHaptic(type: HapticType = 'light'): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    switch (type) {
      case 'light':
      case 'selection':
        navigator.vibrate(8);
        break;
      case 'medium':
        navigator.vibrate(16);
        break;
      case 'success':
        navigator.vibrate([12, 35, 18]);
        break;
      case 'warning':
        navigator.vibrate([28, 45, 28]);
        break;
    }
  } catch {
    // Fail silently on restricted frames or unsupported devices
  }
}
